import React from 'react';
import { motion } from 'framer-motion';

const TermsOfService: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="container mx-auto px-4 py-8 text-white"
    >
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
      <p className="mb-4">
        Welcome to Fantasy Fiesta. By accessing or using our website, you agree to be bound by these Terms of Service.
      </p>
      <h2 className="text-xl font-semibold mb-2">Use of Our Service</h2>
      <p className="mb-4">
        You agree to use our service only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the website.
      </p>
      <h2 className="text-xl font-semibold mb-2">User Accounts</h2>
      <p className="mb-4">
        When you create an account with us, you must provide us information that is accurate, complete, and current at all times.
      </p>
      <h2 className="text-xl font-semibold mb-2">Intellectual Property</h2>
      <p className="mb-4">
        The service and its original content, features, and functionality are and will remain the exclusive property of Fantasy Fiesta and its licensors.
      </p>
      <h2 className="text-xl font-semibold mb-2">Links to Other Websites</h2>
      <p className="mb-4">
        Our service may contain links to third-party web sites or services that are not owned or controlled by Fantasy Fiesta. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third party web sites or services.
      </p>
      <h2 className="text-xl font-semibold mb-2">Termination</h2>
      <p className="mb-4">
        We may terminate or suspend access to our service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
      </p>
      <h2 className="text-xl font-semibold mb-2">Limitation of Liability</h2>
      <p className="mb-4">
        In no event shall Fantasy Fiesta, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages.
      </p>
      <h2 className="text-xl font-semibold mb-2">Governing Law</h2>
      <p className="mb-4">
        These Terms shall be governed and construed in accordance with the laws of the United States without regard to its conflict of law provisions.
      </p>
      <h2 className="text-xl font-semibold mb-2">Changes to Terms</h2>
      <p className="mb-4">
        We reserve the right, at our sole discretion, to modify or replace these Terms at any time.
      </p>
      <p>
        If you have any questions about these Terms, please contact us.
      </p>
    </motion.div>
  );
};

export default TermsOfService;
